export const FORECAST_CATEGORIES_STEP = 0;
export const CATEGORY_MAPPING_STEP = 1;
export const FINISH_STEP = 2;

// Prefix for categories during setup
export const WIZARD_FORECAST_CATEGORY = 'WIZARD_FORECAST_CATEGORY_';